var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPochtaBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pochta_Bank"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V20H20V0ZM3.5 15.1V4.89999H9.45V15.1H7.6V6.49999H5.35V15.1H3.5ZM13.6 8.24999C16.5 8.24999 16.9 10.5 16.95 11.65C17 12.1 16.95 12.55 16.8 12.95C16.65 13.4 16.4 13.75 16.1 14.1C15.8 14.4 15.45 14.7 15.05 14.85C14.65 15 14.2 15.1 13.75 15.1H10.95V4.89999H15.95V6.54999H12.7V8.19999H13.55L13.6 8.24999ZM12.7 13.35C12.7 13.35 13.15 13.45 13.35 13.45C13.9 13.45 15.05 13.35 15.05 11.55C15.05 9.74027 14.0974 9.74501 13.186 9.74954C13.1405 9.74977 13.0951 9.74999 13.05 9.74999H12.7V13.35Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPochtaBank);
export default __webpack_public_path__ + "static/media/pochta_bank.ed5ae099b8467566fd430649ab13f2d1.svg";
export { ForwardRef as ReactComponent };